import getLocationsAndRoomsForHTML from './getLocationsAndRoomsForHTML'

export default async function setUpLocationAndRoomSelection () {
  const locations_and_rooms = await getLocationsAndRoomsForHTML(true)
  const html = '<option value="all">All Locations</option>' + locations_and_rooms
  $('.location-and-room-select').html(html)
}
